import type { ListParams } from '../type';
import baseKey from './_baseKey';

const venueDomainKey = (venueSubDomains?: string[]) =>
  baseKey.domainKey('venue', venueSubDomains);

/**
 * 지점 관련 쿼리키 제너레이터
 */
const venueKey = {
  /**
   * @returns 지점 도메인 기본 쿼리키 (getter)
   * @example ['venue']
   */
  domain() {
    return venueDomainKey();
  },
  /**
   * @returns 전체 지점 리스트 요청 쿼리키
   * @example ['venue', 'list', 'all']
   */
  listAll() {
    return [...baseKey.listKey(venueDomainKey(), 'all')];
  },
  /**
   * @param listParams 고객사 ID 포함한 리스트 파라미터
   * @returns 페이지네이션 방식 지점 리스트 데이터 요청 쿼리키
   * @example ['venue', 'list', 'scroll', {...listParams}]
   */
  listByPage(listParams?: ListParams) {
    return [...baseKey.listKey(venueDomainKey(), 'scroll'), listParams];
  },
  /**
   * @param id 지점 ID
   * @returns 지점의 공간 정보를 포함한 지점 상세 데이터 요청 쿼리키
   * @example ['venue', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(venueDomainKey(), 'detail'), id];
  },
  remarksById(id?: number) {
    if (id) return [...baseKey.itemKey(venueDomainKey(), 'remarks'), id];
    return [...baseKey.itemKey(venueDomainKey(), 'remarks')];
  },
  remarksFieldInfo() {
    return ['remarkFieldInfo'];
  },
  /**
   * @param id 지점 ID
   * @returns 지점의 간략 데이터 요청 쿼리키
   * @example ['venue', 'brief', 1]
   */
  briefById(id: number) {
    return [...baseKey.itemKey(venueDomainKey(), 'brief'), id];
  },
  servicesById(vid: number) {
    return [...baseKey.itemKey(venueDomainKey(), 'services'), vid];
  },
  /**
   * @param bizNumber 사업자등록번호
   * @returns 주어진 사업자등록번호에 해당하는 지점 데이터 개수 요청 쿼리키
   * @example ['venue', 'count', '416-87-01054']
   */
  countByBizNumber(bizNumber: string) {
    return [...baseKey.countKey(venueDomainKey()), bizNumber];
  },
  invoiceByListParams(listParams?: ListParams) {
    return [...baseKey.listKey(venueDomainKey(), 'page'), listParams];
  },
};

export default Object.freeze(venueKey);
